import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/CRMPage.html?vue&type=template&id=2d1ca8dc&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/CRMPage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/CRMPage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/crmPage.scss?vue&type=style&index=0&id=2d1ca8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1ca8dc",
  null
  
)

export default component.exports